// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
    position: relative;
    height: 160px;
    margin: auto;
    overflow: hidden;
  }
  
  .content .content-overlay {
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    height: 99%;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    transition: all 0.4s ease-in-out 0s;
  }
  
  .content:hover .content-overlay {
    opacity: 1;
  }
  
  .content-image {
    width: 100%;
    height: inherit;
  }
  
  .content-details {
    position: absolute;
    text-align: center;
    padding-left: 1em;
    padding-right: 1em;
    width: 100%;
    top: 50%;
    left: 50%;
    opacity: 0;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease-in-out 0s;
  }
  
  .content:hover .content-details {
    top: 50%;
    left: 50%;
    opacity: 1;
  }
  
  .content-details h3 {
    color: #fff;
    font-weight: 500;
    letter-spacing: 0.15em;
    margin-bottom: 0.5em;
    text-transform: uppercase;
  }
  
  .content-details p {
    color: #fff;
    font-size: 0.8em;
  }
  
  .fadeIn-bottom {
    top: 80%;
  }`, "",{"version":3,"sources":["webpack://./src/components/StyledImagePreview/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,UAAU;IAGV,mCAAmC;EACrC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,UAAU;IAGV,gCAAgC;IAGhC,mCAAmC;EACrC;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV","sourcesContent":[".content {\n    position: relative;\n    height: 160px;\n    margin: auto;\n    overflow: hidden;\n  }\n  \n  .content .content-overlay {\n    background: rgba(0, 0, 0, 0.7);\n    position: absolute;\n    height: 99%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    opacity: 0;\n    -webkit-transition: all 0.4s ease-in-out 0s;\n    -moz-transition: all 0.4s ease-in-out 0s;\n    transition: all 0.4s ease-in-out 0s;\n  }\n  \n  .content:hover .content-overlay {\n    opacity: 1;\n  }\n  \n  .content-image {\n    width: 100%;\n    height: inherit;\n  }\n  \n  .content-details {\n    position: absolute;\n    text-align: center;\n    padding-left: 1em;\n    padding-right: 1em;\n    width: 100%;\n    top: 50%;\n    left: 50%;\n    opacity: 0;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    -webkit-transition: all 0.3s ease-in-out 0s;\n    -moz-transition: all 0.3s ease-in-out 0s;\n    transition: all 0.3s ease-in-out 0s;\n  }\n  \n  .content:hover .content-details {\n    top: 50%;\n    left: 50%;\n    opacity: 1;\n  }\n  \n  .content-details h3 {\n    color: #fff;\n    font-weight: 500;\n    letter-spacing: 0.15em;\n    margin-bottom: 0.5em;\n    text-transform: uppercase;\n  }\n  \n  .content-details p {\n    color: #fff;\n    font-size: 0.8em;\n  }\n  \n  .fadeIn-bottom {\n    top: 80%;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
